import { Alert } from "react-bootstrap";
import SideMenu from "./sideMenu";
import { mobileNumberLimit } from "../../config";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CryptoJS from "crypto-js";
import MaterialTable, { MTableToolbar } from "material-table";
import { Box, CircularProgress, TablePagination } from "@material-ui/core";
import { tableIcons } from "../../tableIcons";
import config from "../../config";
import { Input, Typography, Button } from "antd";
import { useCountry } from "../../provider/courtryProvider";
import { withRouter } from "../../utils/withRouter";

const LoyaltyPoints = (props) => {
  const dispatch = useDispatch();
  const shopData = useSelector((state) => state.shopDetails);
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [loyaltyExpired, setloyaltyExpired] = useState(false);
  const [ratioDefined, setRatioDefined] = useState(true);
  const [totalData, setTotalData] = useState([]);
  const [newIndividualArray, setNewIndividualArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const loyaltyExpiryDate = useSelector(
    (state) => state.shopDetails.loyaltyExpiryDate
  );
  const country = useCountry();

  const loyaltyRatio = useSelector((state) => state.shopDetails.loyaltyRatio);
  const shopDetails = useSelector((state) => state.shopDetails);
  const isThereLoyaltyList = useSelector((state) => state.loyaltyFullDetails);

  useEffect(() => {
    if (loyaltyExpiryDate === "") return;
    if (
      Math.ceil(
        (new Date(loyaltyExpiryDate) - new Date()) / (1000 * 60 * 60 * 24)
      ) < 0
    ) {
      setloyaltyExpired(true);
    }
  }, [loyaltyExpiryDate]);
  // useEffect(() => {
  //   console.log("newIndividualArray", newIndividualArray);
  // }, [newIndividualArray]);
  useEffect(() => {
    if (loyaltyRatio === null) {
      setRatioDefined(false);
    }
  }, [loyaltyRatio]);

  useEffect(() => {
    if (isThereLoyaltyList.loyaltyDetailsStored) {
      if (isThereLoyaltyList.shopId == shopDetails.shopId) {
        if (isThereLoyaltyList.loyaltyDetails.length > 0) {
          setNewIndividualArray(isThereLoyaltyList.loyaltyDetails);
          setShowTable(true);
        }
      }
    }
  }, []);

  const getCustomerLoyalty = () => {
    const regExp = /^[0]?[56789]\d{9}$/;
    if (customerPhoneNumber === "") {
      alert("Enter customer mobile number");
      return;
    }
    if (regExp.test(customerPhoneNumber) === false) {
      setTimeout(() => {
        alert("Enter valid phone number");
      }, 100);
      return;
    }
    props.history.push({
      pathname: `/dashboard/loyalty-details`,
      search: `?id=${customerPhoneNumber}`,
    });
  };

  // const getAllCustomerloyaltyDetails = async () => {
  //   setShowTable(true);
  //   setIsLoading(true);
  //   try {
  //     var data = await fetch(
  //       `${config.ApiGateway1}/fetchLoyaltyByNumber`,
  //       // "https://2z4hriwfak.execute-api.ap-south-1.amazonaws.com/dev/fetchLoyaltyByNumber",
  //       {
  //         method: "post",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           shopId: shopDetails.shopId,
  //           export: true,
  //         }),
  //       }
  //     );
  //     var response = await data.json();
  //     console.log("ALL CUST", response);
  //     setTotalData(response);
  //   } catch (err) {
  //     console.log("Loyalty full data fetch Err", err);
  //   }
  // };

  useEffect(() => {
    if (totalData.length > 0) {
      dataAssigner();
    }
  }, [totalData]);

  const getCustomerDetails = async (number) => {
    try {
      var receivedData = await fetch(
        `${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`,

        {
          method: "POST",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            phoneNumber: number,
            shopId: shopDetails.shopId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      var resp = await receivedData.json();
      return resp;
    } catch (err) {
      console.log(err);
    }
  };

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;
    return (
      <TablePagination
        {...tablePaginationProps}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }

  const dataAssigner = async () => {
    var newIndividualArray = [];

    var allUserNumbers = totalData.map((data) => {
      return data.userPhoneNumber;
    });
    var withoutDuplicateNumbers = [...new Set(allUserNumbers)];

    // console.log("withoutDuplicateNumbers", withoutDuplicateNumbers);
    for (var i = 0; i < withoutDuplicateNumbers.length; i++) {
      var tempObj = {
        customerName: "",
        customerPhoneNumber: "",
        totalEarnedPoints: "",
        availablePoints: "",
        redeemedPoints: "",
        customerSince: "",
        lastVisit: "",
        userPhoneNumber: "",
      };
      var name;
      try {
        name = await getCustomerDetails(withoutDuplicateNumbers[i]);
        console.log("customerName", name.customerName);
      } catch (err) {
        console.log(err);
      }
      var individualCustomerData = totalData.filter((data) => {
        if (data.userPhoneNumber == withoutDuplicateNumbers[i]) {
          return data;
        }
      });
      // console.log("individualCustomerData", individualCustomerData);
      var addedpoints = 0;
      var redeemedpoints = 0;
      individualCustomerData.map((data) => {
        console.log(data.points, data.pointsAction);

        if (data.pointsAction == "added") {
          addedpoints += parseFloat(data.points);
        }
        if (data.pointsAction == "redeemed") {
          redeemedpoints += parseFloat(data.points);
        }
      });
      var availablePoints = addedpoints - redeemedpoints;
      // console.log("addedpoints", addedpoints);
      // console.log("redeemedpoints", redeemedpoints);
      // console.log("availablePoints", availablePoints);

      // var totalPointsArray = individualCustomerData.map((data) => {
      //   if (data.pointsAction == "added") {
      //     return parseFloat(data.points);
      //   } else {
      //     return 0;
      //   }
      // });

      // console.log("totalPointsArray", totalPointsArray);

      // var sumOfTotalPoints;

      // if (totalPointsArray.length > 1) {
      //   sumOfTotalPoints = totalPointsArray.reduce(function (
      //     previousValue,
      //     currentValue
      //   ) {
      //     return previousValue + currentValue;
      //   });
      // } else {
      //   sumOfTotalPoints = totalPointsArray[0];
      // }

      // let totalPointsEarned = sumOfTotalPoints;

      // let redemeedPointsArrray = individualCustomerData.map((data) => {
      //   if (data.pointsAction == "redeemed") {
      //     return parseFloat(data.points);
      //   } else {
      //     return 0;
      //   }
      // });
      // var sumOfRedemeedPoints;
      // if (redemeedPointsArrray.length > 1) {
      //   sumOfRedemeedPoints = redemeedPointsArrray.reduce(function (
      //     previousValue,
      //     currentValue
      //   ) {
      //     return previousValue + currentValue;
      //   });
      // } else {
      //   sumOfRedemeedPoints = redemeedPointsArrray[0];
      // }
      // let redeemedPoints = sumOfRedemeedPoints;
      // console.log("redeemed points", redeemedPoints);

      var transactionDates = individualCustomerData.map((data) => {
        return data.transactionDate;
      });
      // console.log("transactionDates", transactionDates);
      var transactionDatesSorted = transactionDates.sort();
      // console.log("transactionDatesSorted", transactionDatesSorted);
      var firstTransaction = transactionDatesSorted[0];
      var lastTransaction =
        transactionDatesSorted[transactionDatesSorted.length - 1];
      // console.log("firstT", firstTransaction, "lastT", lastTransaction);
      tempObj.customerName = name.customerName;
      tempObj.customerPhoneNumber = withoutDuplicateNumbers[i];
      tempObj.totalEarnedPoints = addedpoints;
      tempObj.redeemedPoints = redeemedpoints;
      tempObj.customerSince = firstTransaction;
      tempObj.lastVisit = lastTransaction;
      tempObj.availablePoints = availablePoints;
      tempObj.userPhoneNumber = withoutDuplicateNumbers[i];
      newIndividualArray.push(tempObj);
    }
    console.log("newIndividualArray", newIndividualArray);
    setNewIndividualArray(newIndividualArray);

    dispatch({
      type: "SET_LOYALTY_LIST",
      payload: newIndividualArray,
      shopId: shopDetails.shopId,
    });

    // console.log("newIndividualArray", newIndividualArray);
    setIsLoading(false);
  };
  // console.log("newIndividualArray", newIndividualArray);
  return (
    <>
      <div>
        {loyaltyExpired && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Alert
              style={{
                width: "40%",
                textAlign: "center",
              }}
              variant="danger"
            >
              Loyalty Package Expired
            </Alert>
          </div>
        )}

        {!ratioDefined && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Alert
              style={{
                width: "40%",
                textAlign: "center",
              }}
              variant="danger"
            >
              Loyalty Ratio not defined
            </Alert>
          </div>
        )}
        <form>
          <div
            className="loyaltyInputWrapper"
            style={{ margin: "20px", textAlign: "center" }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                textAlign: "center",
              }}
            >
              <Typography.Title
                style={{
                  fontWeight: 500,
                }}
                level={5}
              >
                Enter Customer Phone Number
              </Typography.Title>
              {/* <Button
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                }}
                type="primary"
                ghost
                onClick={() => getAllCustomerloyaltyDetails()}
              >
                Export Loyalty Details
              </Button> */}
            </div>
            <div>
              <Input
                size="large"
                prefix={
                  <span
                    style={{
                      fontWeight: 500,
                    }}
                  >
                    {country.dialCode}
                  </span>
                }
                placeholder="Customer mobile number"
                onChange={(e) =>
                  setCustomerPhoneNumber(
                    e.target.value.slice(0, country.numberLimit)
                  )
                }
                value={customerPhoneNumber}
                maxLength={country.numberLimit}
                type="number"
                style={{
                  width: "270px",
                }}
              />
            </div>
            <br />
            <Button
              disabled={loyaltyExpired || !ratioDefined}
              onClick={() => getCustomerLoyalty()}
              type="primary"
              ghost
              size="large"
              id="viewCustomerBtn"
            >
              View Customer
            </Button>
            <br />
            {ratioDefined && (
              <p
                style={{
                  marginTop: 8,
                }}
                className="text-muted"
              >
                {shopData.loyaltyPoints} Point(s) is given for{" "}
                {country.CurrencySymbol}
                {shopData.loyaltyAmount}
              </p>
            )}
          </div>
        </form>

        {showTable ? (
          <MaterialTable
            style={{ marginTop: "20px" }}
            columns={[
              {
                title: "Customer Name",
                field: "customerName",
              },
              {
                title: "Phone Number",
                field: "userPhoneNumber",
                // render: (rowData) => {
                //   return <div>{rowData.userPhoneNumber.includes(+91) ? rowData.userPhoneNumber.slice(3,13):rowData.userPhoneNumber}</div>;
                // },
              },
              {
                title: "Total Earned Points",
                field: "totalEarnedPoints",
                render: (rowData) => {
                  return <div>{rowData.totalEarnedPoints.toFixed(1)}</div>;
                },
              },
              {
                title: "Available Points",
                field: "availablePoints",
                render: (rowData) => {
                  return <div>{rowData.availablePoints.toFixed(1)}</div>;
                },
              },
              {
                title: "Redeemed Points",
                field: "redeemedPoints",
                render: (rowData) => {
                  return <div>{rowData.redeemedPoints.toFixed(1)}</div>;
                },
              },
              {
                title: "Customer Since",
                field: "customerSince",
              },
              {
                title: "Last Visit",
                field: "lastVisit",
              },

              {
                title: "View Details",
                render: (data) => {
                  return (
                    <div className="ViewDetailsBtn">
                      <Button
                        variant="outline-danger"
                        onClick={() => {
                          props.history.push({
                            pathname: `/dashboard/loyalty-details`,
                            search: `?id=${
                              data.userPhoneNumber.includes(
                                shopData.country.dialCode
                              )
                                ? data.userPhoneNumber.slice(3, 13)
                                : data.userPhoneNumber
                            }`,
                          });
                        }}
                      >
                        View Details
                      </Button>
                    </div>
                  );
                },
              },
            ]}
            icons={tableIcons}
            data={newIndividualArray}
            title="Loyalty Full Report"
            components={{
              Pagination: PatchedPagination,
            }}
            isLoading={isLoading}
            options={{
              search: true,
              exportButton: {
                csv: true,
              },
              exportAllData: true,
              columnsButton: true,
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default withRouter(LoyaltyPoints);
